import { PageHeader } from '@/components/atoms'
import { PosSettings as PosSettingsForm } from '@/components/features/settings/components'
import { Spinner } from '@/components/ui/spinner'
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'

/** Point of sale → Settings: what the POS apps read (connected devices, hardware, offline credit, returns…). */
const PosSettings = () => {
  const { businessProfile, isLoading, refreshFeatureFlags } = useFeatureFlags()

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner className="size-6 text-muted-foreground" />
      </div>
    )
  }

  return (
    <div className="pb-10">
      <PageHeader size="large" title="Settings" />
      <PosSettingsForm businessProfile={businessProfile} onRefresh={refreshFeatureFlags} />
    </div>
  )
}

export default PosSettings
